import { ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import { makeStyles, useTheme } from "@mui/styles";
import { useSelector } from "react-redux";
import { convertVolume } from "../helpers/convertVolume";
import { formatNumber } from "../helpers/formatNumber";
import { getUnits } from "../helpers/getUnits";
import { normalizeVolume } from "../helpers/normalizeVolume";
import { selectOptions } from "../reducers/optionsSlice";
import { selectUser } from "../reducers/userSlice";
import { ForecastDataTable } from "./ForecastDataTable";
import { WaterfloodChart } from "./WaterfloodChart";
import { WaterfloodChartOptions } from "./WaterfloodChartOptions";

const MONTH_LENGTH = 30.436875;

const useStyles = makeStyles(theme => ({
  root: {
    // backgroundColor: theme.palette.backgroundTwo.dark,
    // backgroundColor: theme.palette.grey[100],
    border: 0,
    color: 'text.primary',
    // overflowY: 'scroll',
    flexBasis: 0,
    flexShrink: 1,
    flexGrow: 1,
    minWidth: 600,
    padding: 0,
    height: 'auto',
    // paddingTop: 10,
    margin: 0,
    // marginTop: 10,
  },
  header: {
    padding: '0 10px',
    paddingTop: 10,
    // backgroundColor: theme.palette.backgroundOne.dark,
    // backgroundColor: theme.palette.grey[200],
  },
  tabs: {
    // backgroundColor: theme.palette.backgroundOne.dark,
    // backgroundColor: theme.palette.grey[200],
    // borderBottom: '1px solid lightgrey',
  },
  cards: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  card: {
    margin: '0 5px',
    height: 120,
    padding: 10,
    flexGrow: 1,
    flexShrink: 0,
    flexBasis: 'auto',
    maxWidth: 400,
  },
  forecastButtons: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end'
  },
  button: {
    borderRadius: '50%'
  },
  status: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginTop: 10
  },
  icon: {
    color: theme.palette.text.secondary
  }
}));

export function WaterfloodContainer({ well, typeCurve }) {

  // const dispatch = useDispatch();
  const classes = useStyles();

  const theme = useTheme();

  const user = useSelector(selectUser);
  const options = useSelector(selectOptions);

  const darkMode = user?.value?.darkMode;


  return (
    <div className={classes.root}>
      {well?.production ? <div>
        <Accordion
          defaultExpanded 
          sx={{boxShadow: 1}}
          style={{
            margin: 10,
            borderRadius: 4,
            border: 'none',
            backgroundColor: theme?.palette?.elevationOne?.[darkMode ? 'dark' : 'light'],
          }}
          elevation={0}
        >
          <AccordionSummary expandIcon={<ExpandMore />}>
            <Typography className={classes.heading} noWrap>Waterflood/Water Drive Chart</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <WaterfloodChartOptions />
            <div style={{height: options?.chartOrientation === 'Horizontal' ? '1000px' : '2000px'}}>
              <WaterfloodChart well={well} />
            </div>
          </AccordionDetails>
        </Accordion>

        <Accordion 
          defaultExpanded
          sx={{boxShadow: 1}}
          style={{
            margin: 10,
            borderRadius: 4,
            border: 'none',
            backgroundColor: theme?.palette?.elevationOne?.[darkMode ? 'dark' : 'light'],
          }}
          elevation={0}
        >
          <AccordionSummary expandIcon={<ExpandMore />} style={{border: 'none'}}>
            <Typography className={classes.heading} noWrap>Waterflood/Water Drive Forecast Summary</Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.details}>
            <EurContainer />
          </AccordionDetails>
        </Accordion>

        <Accordion 
          defaultExpanded
          className={classes.content}
          sx={{boxShadow: 1}}
          style={{
            margin: 10,
            borderRadius: 4,
            border: 'none',
            backgroundColor: theme?.palette?.elevationOne?.[darkMode ? 'dark' : 'light'],
          }}
          elevation={0}
        >
          <AccordionSummary expandIcon={<ExpandMore />}>
            <Typography className={classes.heading} noWrap>Waterflood/Water Drive Forecast Data</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <ForecastDataTable 
              well={well} 
              fluid={'oil'} 
              units={options.units} 
              normalization={options.normalization} 
              typeCurve={typeCurve}
              typeCurveCurrent={false}
            />
          </AccordionDetails>
        </Accordion>
      </div>
      :
      <div style={{width: '100%', height: '90%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        <Typography variant = "h6" color="textSecondary">Production not available</Typography>
      </div>
      }
    </div>
  );

  // function getFlexDirection(eurP10) {
  //   if (document?.getElementById('eur-cards')?.getBoundingClientRect()?.width < 1000 || eurP10 > 100000) return 'column';
  //   return 'row';
  // };

  function EurContainer() {
    try {
      const dateP90 = new Date(well?.eur?.byFluid?.[options?.fluid]?.p90?.date).toDateString().split(' ');
      const dateP50 = new Date(well?.eur?.byFluid?.[options?.fluid]?.p50?.date).toDateString().split(' ');
      const dateP10 = new Date(well?.eur?.byFluid?.[options?.fluid]?.p10?.date).toDateString().split(' ');
      let size = 'h4';

      if (well?.eur?.byFluid?.[options?.fluid]?.p10?.cumVolume > 100000) {
        size = 'h5';
      } else if (well?.eur?.byFluid?.[options?.fluid]?.p10?.cumVolume > 1000000) {
        size = 'h6';
      };

      return (
        <div className={classes.cards} id="eur-cards" style={{flexDirection: 'row'}}>
        {/* <div className={classes.cards} id="eur-cards" style={{flexDirection: getFlexDirection(well?.eur?.byFluid?.[options?.fluid]?.p10?.cumVolume)}}> */}
          <div className={classes.card}>
            <Typography variant="body2">EUR P90</Typography>
            {well?.eur?.byFluid?.[options?.fluid] && 
            <>
              <Typography variant={size} align='left' style={{marginTop: 10}}>
                <span><b>{returnEur('p90')}</b></span> <span style={{fontSize: size === 'h4' ? 24 : size === 'h5' ? 20 : 16}}><b>{getUnits(options)}</b></span>
              </Typography>
              <Typography variant="caption" align='left' style={{marginTop: 20, fontSize: 12}}>
                {`${dateP90[1] || ""}-${dateP90[3] || ""} @${(convertVolume(well?.params?.waterflood?.cutoff, options.units, options.fluid) / MONTH_LENGTH)?.toFixed(2) || ""} ${getUnits(options)}/day`}
              </Typography>
              <Typography variant="caption" style={{display: 'block'}}>Remaining: {calculateRemaining('p90')} {getUnits(options)}</Typography>
            </>}

          </div>
          <div className={classes.card}>
            <Typography variant="body2">EUR P50</Typography>
            {well?.eur?.byFluid?.[options?.fluid] && 
            <>
              <Typography variant={size} align='left' style={{marginTop: 10}}>
                <span><b>{returnEur('p50')}</b></span> <span style={{fontSize: size === 'h4' ? 24 : size === 'h5' ? 20 : 16}}><b>{getUnits(options)}</b></span>
              </Typography>
              <Typography variant="caption" align='left' style={{marginTop: 20, fontSize: 12}}>
                {`${dateP50[1] || ""}-${dateP50[3] || ""} @${(convertVolume(well?.params?.waterflood?.cutoff, options.units, options.fluid) / MONTH_LENGTH)?.toFixed(2) || ""} ${getUnits(options)}/day`}
              </Typography>
              <Typography variant="caption" style={{display: 'block'}}>Remaining: {calculateRemaining('p50')} {getUnits(options)}</Typography>
            </>}
          </div>
          <div className={classes.card}>
            <Typography variant="body2">EUR P10</Typography>
            {well?.eur?.byFluid?.[options?.fluid] && 
            <>
              <Typography variant={size} align='left' style={{marginTop: 10}}>
                <span><b>{returnEur('p10')}</b></span> <span style={{fontSize: size === 'h4' ? 24 : size === 'h5' ? 20 : 16}}><b>{getUnits(options)}</b></span>
              </Typography>
              <Typography variant="caption" align='left' style={{marginTop: 20, fontSize: 12}}>
                {`${dateP10[1] || ""}-${dateP10[3] || ""} @${(convertVolume(well?.params?.waterflood?.cutoff, options.units, options.fluid) / MONTH_LENGTH)?.toFixed(2) || ""} ${getUnits(options)}/day`}
              </Typography>
              <Typography variant="caption" style={{display: 'block'}}>Remaining: {calculateRemaining('p10')} {getUnits(options)}</Typography>
            </>}
          </div>
        </div>
      ); 
      
      // FUNCTIONS
      function returnEur(prob) {
        try {
          if (options?.normalization !== 'off' && (!well.completions || !typeCurve?.details)) return "-";
          let eur = well?.eur?.byFluid?.[options?.fluid]?.[prob]?.cumVolume;
          eur = convertVolume(eur, options.units, options.fluid);
          eur = normalizeVolume(eur, options?.normalization, typeCurve?.details, well?.completions);
          eur = formatNumber(eur.toFixed(1));

          return eur;
        } catch (error) {
          return "-";
        };
      };

      function calculateRemaining(prob) {
        try {
          if (options?.normalization !== 'off' && (!well.completions || !typeCurve?.details)) return "-";
          const eur = well?.eur?.byFluid?.[options?.fluid]?.[prob]?.cumVolume;
          const cumToDate = well?.production?.byFluid?.[options?.fluid]?.slice(-1)?.[0]?.cumVolume;

          let remaining = eur - cumToDate;

          remaining = convertVolume(remaining, options.units, options.fluid);
          remaining = normalizeVolume(remaining, options?.normalization, typeCurve?.details, well?.completions);

          if (isNaN(remaining)) return 0;

          remaining = formatNumber(Math.max(remaining, 0).toFixed(1));
          
          return remaining;
        } catch (error) {
          return "-";
        };
      };
      
    } catch (error) {
      return <></>;
    };
  };
};

